import React from 'react';
import { LandingPage, landingPages } from './pages';

interface LandingInfoProps {
  page: LandingPage;
  onStart?: () => void;
}

// Below-the-fold content for a landing page. Pure render (no browser APIs) so the
// prerender script can render it to static HTML with react-dom/server.
const LandingInfo: React.FC<LandingInfoProps> = ({ page, onStart }) => {
  const related = landingPages.filter((p) => p.path !== page.path);

  return (
    <section className="th-seo" aria-label={`About the ${page.h1.toLowerCase()}`}>
      <div className="th-seo-inner">
        {page.intro.map((para) => (
          <p key={para} className="th-seo-lede">
            {para}
          </p>
        ))}

        <h2>How it works</h2>
        <ol className="th-seo-steps">
          <li>Write the one thing you want to finish.</li>
          <li>Set the length and pick a sound: lofi, focus music, nature, white noise or silence.</li>
          <li>Press enter. The scene opens, the music starts and the timer counts down.</li>
        </ol>

        <h2>Questions</h2>
        <dl className="th-seo-faq">
          {page.faqs.map((f) => (
            <div key={f.q}>
              <dt>{f.q}</dt>
              <dd>{f.a}</dd>
            </div>
          ))}
        </dl>

        {onStart && (
          <button className="th-enter th-seo-start" onClick={onStart}>
            start the {page.h1.toLowerCase()} <kbd>↵</kbd>
          </button>
        )}

        <h2>More timers</h2>
        <ul className="th-seo-links">
          {related.map((p) => (
            <li key={p.path}>
              <a href={p.path}>{p.h1}</a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default LandingInfo;
